// extracted by mini-css-extract-plugin
export default {"cronometro":"Cronometro_cronometro__0-MU8","relogioWrapper":"Cronometro_relogioWrapper__5TuS-","titulo":"Cronometro_titulo__Cnrdj"};